import { tracking } from '@iwoca/frontend-tracking-library';
import { Button, Modal } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { getAmplitudeDefaultEventProperties } from 'utils/amplitudeEvents';
import { triggerRelaunchStep } from '../helpers/relaunchStepHelpers';
import styles from './FirstAppModal.module.css';

type TProps = {
  triggerTour: () => void;
  showModal: boolean;
  closeModal: () => void;
};

export const FirstAppModal = ({
  triggerTour,
  showModal,
  closeModal,
}: TProps) => {
  const { introducerId } = useIntroducerData();
  const onTakeTourClick = () => {
    closeModal();
    tracking.ampli.ctaClick({
      ...getAmplitudeDefaultEventProperties(),
      'CTA text': 'Take the tour',
      'CTA type': 'First app modal',
    });
    tracking.ampli.tutorialStarted({
      ...getAmplitudeDefaultEventProperties(),
      name: 'Dashboard',
    });
    triggerTour();
  };

  return (
    <Modal
      className={styles.modal}
      isOpen={showModal}
      onClose={closeModal}
      title={t`You've successfully created your first application! 🎉`}
    >
      <p className={styles.text}>
        <Trans>
          Start exploring dashboard features to help manage your applications
          more efficiently.
        </Trans>
      </p>
      <Button className={styles.button} onClick={onTakeTourClick}>
        <Trans>Take the tour</Trans>
      </Button>

      <Button
        className={styles.secondaryButton}
        variant="tertiary"
        onClick={() => {
          triggerRelaunchStep({
            introducerId,
            tutorial: 'first_application',
          });
          tracking.ampli.ctaClick({
            ...getAmplitudeDefaultEventProperties(),
            'CTA text': 'Maybe later',
            'CTA type': 'First app modal',
          });
          closeModal();
        }}
      >
        <Trans>Maybe later</Trans>
      </Button>
    </Modal>
  );
};
